import angular from 'angular';
import categoryComponent from './category.component';
import CategoryService from './category.service';
import categoryConfig from './category.config';
import CategoryPagerToolboxModule from './category-pager-toolbox/category-pager-toolbox';
import CategoryProducts from './category-products/category-products';

let categoryModule = angular.module('category',[
  CategoryPagerToolboxModule.name,
  CategoryProducts.name
])
  .component('category', categoryComponent)
  .service('CategoryService', CategoryService)
  .config(categoryConfig);

export default categoryModule;



// WEBPACK FOOTER //
// ./www/components/catalog/category/category.js